import { ca } from '@cian/analytics';

function getDefaultTrackingParams(id: number) {
  return {
    name: 'oldevent',
    products: [
      {
        id,
        offerType: 'offer',
        position: 1,
      },
    ],
  };
}

export function trackProjectsBlockRender(id: number) {
  const defaultParams = getDefaultTrackingParams(id);

  ca('eventSite', {
    ...defaultParams,
    action: 'Downloaded',
    category: 'build_house',
    label: '',
  });
}

export function trackProjectsBlockView(id: number) {
  const defaultParams = getDefaultTrackingParams(id);

  ca('eventSite', {
    ...defaultParams,
    action: 'Show',
    category: 'build_house',
    label: 'buildings_block',
  });
}

export function trackProjectsBlockButtonClick(id: number) {
  const defaultParams = getDefaultTrackingParams(id);

  ca('eventSite', {
    ...defaultParams,
    action: 'Click',
    category: 'build_house',
    label: 'buildings_block_button',
  });
}

export function trackProjectsBlockPhotoClick(id: number) {
  const defaultParams = getDefaultTrackingParams(id);

  ca('eventSite', {
    ...defaultParams,
    action: 'Click',
    category: 'build_house',
    label: 'buildings_block_photo',
  });
}
